import { apiService } from "./apiService";
import apiRoutes from "./apiRoutes"; // Add your route string here if needed

export const toggleFavorite = async (payload) => {
  const response = await apiService.post(`${apiRoutes.toggleFavorite}`, payload);
  return response.data;
};


export const followUser = async (receiverId) => {
  const response = await apiService.get(`${apiRoutes.followUser}?receiverId=${receiverId}`);
  return response.data;
};

export const checkFollowStatus = async (senderId, receiverId) => {
  const response = await apiService.get(`${apiRoutes.checkFollowStatus}?senderId=${senderId}&receiverId=${receiverId}`);
  return response.data;
};

export const getMyFavorite = async (filter = "", page = 1, limit = 10) => {
  const response = await apiService.get(apiRoutes.getMyFavorite, {
    filter,
    page,
    limit,
  });
  return response.data;
};

export const getMyProductSupport = async (filter = "", page = 1, limit = 10) => {
  const response = await apiService.get(apiRoutes.getMyProductSupport, {
    filter,
    page,
    limit,
  });
  return response.data;
};
export const getMyProductSupportWithoutLimit = async () => {
  const response = await apiService.get(apiRoutes.getMyProductSupportWithoutLimit, {
  });
  return response.data;
};

export const getProductList = async () => {
  const response = await apiService.get(apiRoutes.getProductList);
  return response.data;
};

export const createSupportList = async (payload) => {
  const response = await apiService.post(`${apiRoutes.createSupportList}`, payload);
  return response.data;
};
export const updateSupportList = async (payload) => {
  const response = await apiService.post(`${apiRoutes.updateSupportList}`, payload);
  return response.data;
};


export const deleteSupportList = async (id) => {
  const response = await apiService.get(`${apiRoutes.deleteSupportList}?id=${id}`);
  return response.data;
};


export const getNotificationList = async (page = 1, limit = 10) => {
  const response = await apiService.get(apiRoutes.getNotificationList, {
    page,
    limit,
  });
  return response.data;
};

export const getFollowersList = async (page = 1, limit = 10, search = "") => {
  const response = await apiService.get(apiRoutes.getFollowersList, {
    page,
    limit,
    search
  });
  return response.data;
};

export const getFollowingList = async (page = 1, limit = 10, search = "") => {
  const response = await apiService.get(apiRoutes.getFollowingList, {
    page,
    limit,
    search
  });
  return response.data;
};

export const removeFollowOrUnfollow = async (targetId) => {
  const response = await apiService.get(`${apiRoutes.removeFollowOrUnfollow}?targetId=${targetId}`);
  return response.data;
};

export const getMyReviewList = async (filter = "", userId, page = 1, limit = 10, authId = null) => {
  const response = await apiService.get(`${apiRoutes.getMyReviewList}?userId=${userId}&filter=${filter}&page=${page}&limit=${limit}&authId=${authId}`);
  return response.data;
};

export const getFilters = async (category, slug) => {
  const response = await apiService.get(`${apiRoutes.getFilters}?category=${category}&slug=${slug}`);
  return response.data;
};

export const getPriceRangeLimits = async () => {
  const response = await apiService.get(`${apiRoutes.getPriceRangeLimits}`);
  return response.data;
};

export const searchHome = async (term) => {
  const response = await apiService.get(`${apiRoutes.searchHome}?search=${term}`);
  return response.data;
};

export const toggleHelpful = async (reviewId) => {
  const response = await apiService.get(`${apiRoutes.toggleHelpful}?reviewId=${reviewId}`);
  return response.data;
};
